module.exports = __webpack_public_path__ + "static/photo-dandapat--04958ed66f16bd68343294c3c6757cf1.jpg";